import { useTheme } from '@mui/material/styles';
import { THEME_TYPE } from '../../consts';

/**
 * Hook to determine the current mui theme brightness (light or dark).
 */
const useThemeBrightness = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return isDarkMode ? THEME_TYPE.DARK : THEME_TYPE.LIGHT;
};

export default useThemeBrightness;
